/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PaymentMethodCode = 'B' | 'F' | 'H' | 'S' | 'Z' | 'I' | 'K' | 'O';

export const PaymentMethodCode = {
    B: 'B' as PaymentMethodCode,
    F: 'F' as PaymentMethodCode,
    H: 'H' as PaymentMethodCode,
    S: 'S' as PaymentMethodCode,
    Z: 'Z' as PaymentMethodCode,
    I: 'I' as PaymentMethodCode,
    K: 'K' as PaymentMethodCode,
    O: 'O' as PaymentMethodCode
};

